import { ReactComponent as DownloadSvg } from '../../assets/icons/download.svg';

export const DownloadIcon: SvgIcon = (props) => {
    return <DownloadSvg {...props} />;
};
